import { render, staticRenderFns } from "./AnonFeedbackCard.vue?vue&type=template&id=35b58eb9"
import script from "./AnonFeedbackCard.vue?vue&type=script&lang=js"
export * from "./AnonFeedbackCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports